import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { USER_ACTIVITY } from "../config/apiEndPoint";
import { POST } from "config/api.config";
import { DEFAULT_PAGE_SIZE } from "helpers/GeneralHelper";


/** POST `User/UserActivity/chart` — multi-series activity line chart. */
export const fetchUserActivityChart = async (data = {}) => {
    try {
        const response = await POST(USER_ACTIVITY.CHART, data);
        return response;
    } catch (error) {
        toast.error(error?.message || "Unable to load user activity chart");
        return null;
    }
};

/** POST `User/UserActivity/summary/filter` — paginated user activity summary list. */
export const submitUserActivitySummaryFilter = async (data = {}) => {
    try {
        const response = await POST(USER_ACTIVITY.SUMMARY_FILTER, data);
        return response;
    } catch (error) {
        toast.error(error?.message || "Unable to load user activity summary");
        return null;
    }
};

/** POST `User/UserActivity/sessions/filter` — login sessions for expanded summary row. */
export const submitUserActivitySessionsFilter = async (data = {}) => {
    const userId = String(data?.userId ?? "").trim();
    if (!userId) {
        toast.error("User id is required");
        return null;
    }

    try {
        const response = await POST(USER_ACTIVITY.SESSIONS_FILTER, {
            userId,
            pageNumber: Number(data?.pageNumber) || 1,
            pageSize: Number(data?.pageSize) || DEFAULT_PAGE_SIZE,
        });
        return response;
    } catch (error) {
        toast.error(error?.message || "Unable to load user activity sessions");
        return null;
    }
};
